module.exports = __webpack_public_path__ + "html/section-background-text_c4a28c7484115fc9e7573956afede14c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-background-text.html
// module id = /MmQ
// module chunks = 68